import ComponentHelper from './ComponentHelper';
import localForage from 'localforage';
import StorageService from '../services/StorageService';

let SS = new StorageService();

class ComponentWithMemory extends ComponentHelper {
	constructor(props) {
		super(props);
		this.componentKey = null;
		this.sessionOnly = true;
	}

	clearMemory() {
		if (this.componentKey) {
			this.data = null;
			localForage.setItem(this.componentKey, null);
		}
	}

	persistAllChanges() {
		this.sessionOnly = false;
	}

	setComponentKey = key => {
		if (key) this.componentKey = key;
	};

	pushChanges() {
		super.pushChanges();
		if (this.componentKey) {
			SS.storeComponentData(this.componentKey, this.data);
		}
	}

	componentWillUnmount = () => {
		if (this.componentKey && this.data) {
			SS.storeComponentData(this.componentKey, this.data);
		}
	};

	componentWillMount = () => {
		if (this.componentKey) {
			SS.getComponentData(this.componentKey, this.sessionOnly).then(res => {
				if(res) {
					this.data = res;
					this.pushChanges();
				}
			});
		}
	};
}

export default ComponentWithMemory;



// WEBPACK FOOTER //
// ./src/supers/ComponentWithMemory.js